export default [
  {
    name: 'custom_header_milesforhumanity',
    path: 'modules/pages/milesforhumanity/HeaderMilesforhumanity'
  }
]